import { gql } from '@urql/core';
import { createQueryKeys } from '@lukemorales/query-key-factory';

export const funnelsFeatureKeys = createQueryKeys('funnelFeature', {
  funnelList: ({ siteId, limit, field, sort, search }) => [
    {
      siteId,
      limit,
      order: {
        field,
        sort,
      },
      search,
    },
  ],
  funnelDetail: ({ id }) => [
    {
      id,
    },
  ],
  funnelsUsingGoals: ({ siteId, goalIds }) => [
    {
      siteId,
      goalIds,
    },
  ],
  funnelResult: ({ siteId, startAt, endAt, timeUnit, steps }) => [
    {
      siteId,
      startAt,
      endAt,
      timeUnit,
      steps,
    },
  ],
});

export const funnelResultQuery = ({ siteId, startAt, endAt, timeUnit, steps }) => ({
  ...funnelsFeatureKeys.funnelResult({ siteId, startAt, endAt, timeUnit, steps }),
  meta: {
    query: gql`
      query FunnelResult($siteId: Int!, $startAt: Int!, $endAt: Int!, $timeUnit: TimeUnit!, $steps: [FunnelStep!]!) {
        funnelResult(siteId: $siteId, startAt: $startAt, endAt: $endAt, timeUnit: $timeUnit, steps: $steps) {
          steps {
            uniqueVisitors
            totalVisitors
            value {
              displayCurrency
              displayWorth
            }
          }
          timeUnitResults {
            startAt
            endAt
            steps {
              uniqueVisitors
              uniqueConversionRate
              totalVisitors
              value {
                displayWorth
              }
            }
          }
        }
      }
    `,
  },
});

export const funnelFragment = gql`
  fragment funnel on Funnel {
    createdAt
    createdBy {
      name
    }
    id
    name
    visitStep
    goalSteps {
      id
      name
      autoName
      display_data
    }
    siteId
  }
`;

export const funnelListQuery = ({ siteId, limit, field, sort, search }) => ({
  ...funnelsFeatureKeys.funnelList({ siteId, limit, field, sort, search }),
  meta: {
    query: gql`
      query FunnelList($siteId: Int, $cursor: String, $limit: Int, $order: FunnelListOrder, $search: String) {
        funnelList(siteId: $siteId, cursor: $cursor, limit: $limit, order: $order, search: $search) {
          hasNextPage
          nextPageCursor
          funnels {
            ...funnel
          }
        }
      }
      ${funnelFragment}
    `,
  },
});

export const funnelDetailQuery = ({ id }) => ({
  ...funnelsFeatureKeys.funnelDetail({ id }),
  useErrorBoundary: false,
  meta: {
    query: gql`
      query FunnelDetail($id: Int!) {
        funnelDetail(id: $id) {
          ...funnel
        }
      }
      ${funnelFragment}
    `,
  },
});

export const funnelsUsingGoalsQuery = ({ siteId, goalIds }) => ({
  ...funnelsFeatureKeys.funnelsUsingGoals({ siteId, goalIds }),
  staleTime: 0,
  refetchOnWindowFocus: true,
  meta: {
    query: gql`
      query FunnelsUsingGoals($siteId: Int!, $goalIds: [Int!]!) {
        funnelsUsingGoals(siteId: $siteId, goalIds: $goalIds) {
          ...funnel
        }
      }
      ${funnelFragment}
    `,
  },
});
